import { MyRightsForAPoint, MyRightsForPoints } from '@shared/models/rights';
import { MyManagementRightsDto, MyRightsDto } from '../interfaces/dtos';
import { MyManagementRights, MyRightsDetail } from '../interfaces/rights';
import { MyRightsForAPointDto, MyRightsForPointsDto } from '@shared/interfaces/dtos/rights';

export abstract class RightsMapper {
  public static toMyRights(rights: MyRightsDto): MyRightsDetail {
    const { globalAccessRight, managementAccessRight, globalDelibeRight } = rights;
    return {
      hasAccessToDelibe: globalAccessRight.accessDelibe,
      hasAccessToDelibeMandataireAdminstration: globalAccessRight.accessAdminDelibeMandataires,
      hasAccessToISign: globalDelibeRight.canUseISign,
      hasAcccessToDocumentModels: managementAccessRight.accesModeleDocument,
      canImport3P: globalDelibeRight.import3P,
      canImportURBAWEB: globalDelibeRight.importURBAWEB,
      canDeleteMeeting: globalDelibeRight.suppressionSeance,
      canManageLibrary: globalDelibeRight.gestionBibliotheque,
      canManageLibraryService: globalDelibeRight.gestionBibliothequeService,
      canManagePrivateLibrary: globalDelibeRight.gestionBibliothequePrive,
      canGenerateCompliantExtract: globalDelibeRight.canGenerateExtraitConf,
      canManageDelibe: globalDelibeRight.isAdminIScan,
      isIScanAdmin: globalDelibeRight.isAdminIScan,
    };
  }

  public static toMyManagementRights(managementRights: MyManagementRightsDto): MyManagementRights {
    return {
      menu: {
        forAdministration: managementRights.menu.administration,
        forDelibeMandataires: managementRights.menu.administrationDelibeMandataires,
        forObjectModels: managementRights.menu.modeleObjets,
        forDeliberationsManagement: managementRights.menu.gestionDeliberations,
        forDocumentModels: managementRights.menu.modelesDocuments,
        forParagraphLibrary: managementRights.menu.bibliothequeParagraphes,
        forDelibeAccess: managementRights.menu.accessDelibe,
        toImport3P: managementRights.menu.import3P,
        toImportURBAWEB: managementRights.menu.importURBAWEB,
        toDeleteMeeting: managementRights.menu.suppressionSeance,
        isIScanAdmin: managementRights.menu.isAdminIscan,
      },
    };
  }

  public static toMyRightsForPoints(rights: MyRightsForPointsDto): MyRightsForPoints {
    return new MyRightsForPoints()
      .setRights({
        changeStatus: rights.changerStatut,
        viewCurrentStatus: rights.viewActualStatut,
        changeMatter: rights.changerMatiere,
        viewCurrentMatter: rights.viewActualMatiere,
        changeAldermanship: rights.changerEchevinat,
        viewCurrentAlderman: rights.viewActualEchevinat,
        changePointType: rights.changerTypePoint,
        viewCurrentPointType: rights.viewActualTypePoint,
      })
      .setAllowedStatusesIds(rights.changerStatutAllowedIds)
      .setViewableStatusesIds(rights.viewStatutAllowedIds)
      .setAllowedMattersIds(rights.changerMatiereAllowedIds)
      .setViewableMattersIds(rights.viewMatiereAllowedIds)
      .setAllowedAldermanIds(rights.changerEchevinatAllowedIds)
      .setViewableAldermanIds(rights.viewEchevinatAllowedIds)
      .setAllowedPointTypeIds(rights.changerTypePointAllowedIds)
      .setViewablePointTypeIds(rights.viewTypePointAllowedIds);
  }

  public static toMyRightsForAPoint(rights: MyRightsForAPointDto): MyRightsForAPoint {
    return new MyRightsForAPoint()
      .setRights({
        amIManager: rights.isGestionnaire,
        edit: rights.edit,
        duplicate: rights.duplicate,
        changeStatus: rights.changerStatut,
        viewFiles: rights.files.view,
        addFiles: rights.files.add,
        editFiles: rights.files.edit,
        deleteFiles: rights.files.delete,
        openFiles: rights.files.open,
        openMeeting: rights.openSeance,
      })
      .setAllowedStatusesIds(rights.changerStatut ? rights.changerStatutAllowedIds : []);
  }
}
